<div class="card">
    <div>
        <p class="font-bold m-0">{{card().details.holder}}</p>
        <a (click)="deleteCard()">Delete Card</a>
        <div>
            <p class="font-light m-0">{{card().details.brand}} - Ending in {{card().details.last4Digits}} | Expires on {{card().details.expiryMonth}}/{{card().details.expiryYear}}</p>
        </div>
    </div>
</div>